import { render, staticRenderFns } from "./card-strategy-running.component.vue?vue&type=template&id=47d8d47d&scoped=true"
import script from "./card-strategy-running.component.vue?vue&type=script&lang=js"
export * from "./card-strategy-running.component.vue?vue&type=script&lang=js"
import style0 from "./card-strategy-running.component.vue?vue&type=style&index=0&id=47d8d47d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d8d47d",
  null
  
)

export default component.exports